import {selectNavOption} from "../helpers/nav_option_helpers";
import {clearExperienceMarker, clearNavOption} from "../helpers/commit_helpers";

export default function filterRouteRequested(sm, mapFilter) {
    const navOption = mapFilter?.onlineAppNavOption;
    if (navOption) {
        selectNavOption(sm, navOption);
        // On the INITIAL deep-link resolution, tell the Nav to preserve its restored persisted
        // navOpen rather than apply this option's nav-toggle instruction (plan 2026-07-20 follow-up).
        navOption.fireSelectedWithRouteRequestEvent({ isInitialRoute: sm.getStateableObject().hasPendingInitialRoute() }); // Event to be picked up by the Nav's PaneOptionComponent event listener.
    } else {
        if(isCurrentNavOption(sm)) clearNavOption(sm);
    }

    // If there is an experienceMarker open then we close it…
    if(isCurrentExperienceMarker(sm)) { clearExperienceMarker(sm) }

}

// Private…

function isCurrentExperienceMarker(sm) {
    return !!sm.state['experienceMarker'];
}

function isCurrentNavOption(sm) {
    return !!sm.state['navOption'];
}